import { Button } from "../../../Button/Default/mod.ts";
import { TwoButtonType } from "./types.ts";
import { useEffect, useSignal } from "../../../deps.ts";
import { Loader } from "./Loader.tsx";

export const TwoButtons = (
  {
    primaryButton,
    secondaryButton,
    toggleModal,
    isOpened = false,
  }: TwoButtonType,
) => {
  const isLoading = useSignal(false);
  useEffect(() => {
    isLoading.value = false;
  }, [isOpened]);

  const onClickOnPrimaryButtonHandler = (event: MouseEvent) => {
    if (!primaryButton.isManualToggle) {
      toggleModal();
    } else {
      isLoading.value = true;
    }
    primaryButton.onClick && primaryButton.onClick(event);
  };

  const onClickOnSecondaryButtonHandler = (event: MouseEvent) => {
    if (!secondaryButton.isManualToggle) {
      toggleModal();
    } else {
      isLoading.value = true;
    }
    secondaryButton.onClick && secondaryButton.onClick(event);
  };
  if (isLoading.value) {
    return <Loader />;
  }
  return (
    <div className={"flex flex-col sm:flex-row sm:justify-between"}>
      <div>&nbsp;</div>
      <div className={"grid grid-cols-1 gap-l sm:grid-cols-2"}>
        <Button
          variant={"secondary"}
          leadingIcon={secondaryButton.leadingIcon}
          trailingIcon={secondaryButton.trailingIcon}
          onClick={onClickOnSecondaryButtonHandler}
        >
          {secondaryButton.text}
        </Button>
        <Button
          variant={"primary"}
          leadingIcon={primaryButton.leadingIcon}
          trailingIcon={primaryButton.trailingIcon}
          onClick={onClickOnPrimaryButtonHandler}
        >
          {primaryButton.text}
        </Button>
      </div>
    </div>
  );
};
